import moment from 'moment';
import { cloneDeep } from 'lodash-es';
import { isBlank } from 'utils/isBlank';
import { isPresent } from 'utils/isPresent';

export default class Utils {
  static formatPhoneNumber(phoneNumber) {
    var regexObj = /^(?:\+?1[-. ]?)?(?:\(?([0-9]{3})\)?[-. ]?)?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (regexObj.test(phoneNumber)) {
      var parts = phoneNumber.match(regexObj);
      var phone = '';
      if (parts[1]) {
        phone += '(' + parts[1] + ') ';
      }
      phone += parts[2] + '-' + parts[3];
      return phone;
    } else {
      return phoneNumber;
    }
  }

  static openURLOnClick(url) {
    return (event) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(url);
      } else {
        window.location.href = url;
      }
    };
  }

  static parseErrorMessage(error) {
    if (
      isPresent(error.response) &&
      isPresent(error.response.data) &&
      isPresent(error.response.data.error) &&
      isPresent(error.response.data.error.message)
    ) {
      return error.response.data.error.message;
    } else if (isPresent(error.response) && isPresent(error.response.data) && isPresent(error.response.data.error)) {
      return error.response.data.error;
    } else {
      return error.message;
    }
  }

  static formattedDate(date) {
    let dateObj = moment(date);
    return dateObj.isValid() ? dateObj.format('MM/DD/YYYY') : 'Invalid Date';
  }

  static formattedDateMonthDay(date) {
    let dateObj = moment(date);
    return dateObj.isValid() ? dateObj.format('ll') : 'Invalid Date';
  }

  static formattedDateTime(dateTime) {
    return moment(dateTime).format('MM/DD/YYYY LT');
  }

  static formattedWeekdayDate(dateTime) {
    return moment(dateTime).format('dddd, MMM Do');
  }

  static parseDayOfTheWeek(date) {
    let dateObj = moment(date);
    return dateObj.isValid() ? dateObj.format('dddd') : 'Invalid Date';
  }

  static removeNullValues(values) {
    return values.filter((element) => element !== null);
  }

  /**
   * Calculates color brightness based on W3C formula
   * @see https://www.w3.org/TR/AERT/#color-contrast
   * @param {string} hex a string representing a hex color e.g `ffffff`. Supports 3 and 6 digit hex values.
   * @returns {number} brightness in the range of 0-255. Returns 0 if provided hex is invalid.
   */
  static calculateBrightness(hex) {
    const hexValue = hex.replace(/^#/, '');
    const isValidHexValue = /^([0-9a-f]{3}){1,2}$/i.test(hexValue);
    if (!isValidHexValue) return 0;

    const longHexValue =
      hexValue.length === 3
        ? hexValue
            .split('')
            .map((x) => x + x)
            .join('')
        : hexValue;

    const [r, g, b] = longHexValue.match(/\w\w/g).map((x) => parseInt(x, 16));
    return (r * 299 + g * 587 + b * 114) / 1000;
  }

  static capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  static uncapitalize(value) {
    return value.charAt(0).toLowerCase() + value.slice(1);
  }

  /**
      parseUrlParams is deprecated
      use parseQueryString from ParameterUtilities
     */
  static parseUrlParams() {
    const search = window.location.search.substring(1);

    return isPresent(search)
      ? JSON.parse(
          '{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
        )
      : {};
  }

  static deepClone(originalObject) {
    return cloneDeep(originalObject);
  }

  static rgbToHex(rgb) {
    rgb = rgb.replace(/[^\d,]/g, '').split(',');
    return '#' + ((1 << 24) + (+rgb[0] << 16) + (+rgb[1] << 8) + +rgb[2]).toString(16).slice(1);
  }

  static parseInitials(name) {
    if (isBlank(name)) {
      return '';
    }

    const nameArray = name.split(' ');

    if (nameArray.length === 1) {
      return nameArray[0][0];
    }

    const firstName = nameArray[0];
    const lastName = nameArray[nameArray.length - 1];

    return `${firstName[0]}${lastName[0]}`;
  }

  static replaceUnderscoreWithSpace(value) {
    return value?.replace(/_/g, ' ');
  }

  static replaceSpaceWithUnderscore(value) {
    return value?.replace(/ /g, '_');
  }

  static userFriendlyBoolean(value) {
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'string') return value === 'true' ? 'Yes' : 'No';
    return undefined;
  }

  static escapeStringRegexp(value) {
    if (typeof value !== 'string') {
      return value;
    }

    return value.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
  }
}
